import { render, staticRenderFns } from "./tm-page-header.vue?vue&type=template&id=3f431d39&scoped=true&"
import script from "./tm-page-header.vue?vue&type=script&lang=ts&"
export * from "./tm-page-header.vue?vue&type=script&lang=ts&"
import style0 from "./tm-page-header.vue?vue&type=style&index=0&id=3f431d39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f431d39",
  null
  
)

export default component.exports